<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="none" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 교육년도 -->
          <c-datepicker
            name="search"
            type="year"
            label="LBL0002847"
            default="today"
            v-model="searchParam.educationYear"
          ></c-datepicker>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 교육종류1 -->
          <c-select
            codeGroupCd="EDU_KIND_FST_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="LBL0002933"
            v-model="searchParam.educationKindCdLarge"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 교육종류2 -->
          <c-select
            codeGroupCd="EDU_KIND_SEC_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdSmall"
            label="LBL0002934"
            v-model="searchParam.educationKindCdSmall"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 교육구분 -->
          <c-select
            codeGroupCd="EDU_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="educationTypeCd"
            label="LBL0002935"
            v-model="searchParam.educationTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 연간 교육 계획 목록 -->
    <c-table
      ref="table"
      title="LBL0002848"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :filtering="false"
      :checkClickFlag="false"
      :isExcelDown="true"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-appr-btn 
            ref="appr-btn"
            name="work-permit-appr-btn"
            :editable="editable"
            :approvalInfo="approvalInfo"
            @requestAfterAction="getList"
          />
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLADD" icon="add" @btnClicked="linkClick" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template slot="suffixTitle">
        <font v-if="yearEdu.sysApprovalRequestId" class="text-negative" style="font-size:0.8em;font-weight:300;">
          <!-- {{searchYear}}년 {{yearEdu.plantName}} 연간교육계획은 현재 <b>{{yearEdu.approvalStatusName}}</b> 상태입니다. -->
          {{suffixLabel}}
        </font>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
export default {
  name: 'annual-education-plan',
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'eduCourseId' },
          { index: 1, colName: 'eduCourseId' },
        ],
        columns: [],
        data: [],
        
      },
      searchParam: {
        plantCd: null,
        educationYear: '',
        educationKindCdSmall: null,
        educationKindCdLarge: null,
        educationTypeCd: null,
        legalEduYn: null,
      },
      yearEdu: {
        eduEducationYearPlanId: '',  // 연간교육 일련번호
        plantCd: '',  // 사업장 코드
        plantName: '',  // 사업장
        educationYear: '',  // 교육년도
        sysApprovalRequestId: '',  // 결재요청번호
        approvalStatusCd: '', // 결재관련 결재상태
        approvalStatusName: '',
      },
      searchYear: '',
      editable: true,
      listUrl: '',
      yearEduDetailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      suffixLabel: '',
    };
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.yearEdu.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.yearEdu.approvalStatusCd, 
        apprEditable: this.yearEdu.approvalStatusCd === null || this.yearEdu.approvalStatusCd == 'ASC0000001', // 결재버튼 활성화 기준
        param: this.yearEdu, // 결재 param
        approvalUrl: null, // 결재 url
        isApproval: null, // 결재 submit
        approvalTypeCd: 'APTC000005', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          eduEducationYearPlanId: this.yearEdu.eduEducationYearPlanId,
          isApprContent: true
        },
        approvalRequestName: this.searchParam.educationYear + '년 ' + this.yearEdu.plantName + ' 연간교육계획 결재', // 결재요청명 (문서 title)
        approvalConnId: this.yearEdu.eduEducationYearPlanId, // 결재연결용 업무일련번호 (문서 key)
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.suffixLabel = this.$comm.getLangLabel('LBL0002849', {s1: this.searchYear, s2: this.yearEdu.plantName, s3: this.yearEdu.approvalStatusName})
      // url setting
      this.listUrl = selectConfig.sop.edu.annual.list.url;
      this.yearEduDetailUrl = selectConfig.sop.edu.yearEdu.get.url;
      // list setting
      let yearmonth = []
      for(let i = 1; i <= 12; i++) {
        let month = this.$_.padStart(String(i), 2, '0');
        yearmonth.push({
          name: 'mon' + month,
          field: 'mon' + month,
          label: i + this.$comm.getLangLabel('LBL0002853'), //월
          align: 'center',
          sortable: false,
          child: [
            {
              name: 'monplan' + month,
              field: 'monplan' + month,
              // 계획
              label: 'LBLPLAN',
              align: 'center',
              style: 'width:40px', 
              sortable: false,
              type: "link",
            },
            {
              name: 'monresult' + month,
              field: 'monresult' + month,
              // 결과
              label: 'LBL0002852',
              align: 'center',
              style: 'width:40px', 
              sortable: false,
              type: "link",
            },
          ]
        })
      }
      // 연간교육일정
      // 연간 교육일정으로 세운 교육계획정보가 카운트됩니다.
      const yearLabel = `연간교육일정 `
        + `<font class="text-negative" style="font-size:0.9em;font-weight:500;">`
        + `(✅`
        + `연간 교육일정으로 세운 교육계획정보가 카운트됩니다.`
        + `)`
        + `</font>`;
      this.grid.columns = [
          {
          name: "plantName",
          field: "plantName",
          // 사업장
          label: "LBLPLANT",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          name: "educationCourseName",
          field: "educationCourseName",
          // 교육과정
          label: "LBL0002930",
          align: "left",
          style: 'width:200px',
          sortable: true,
          type: "link",
        },
        {
          name: "educationKindCdLargeName",
          field: "educationKindCdLargeName",
          // 교육종류1
          label: "LBL0002933",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          name: "educationKindCdSmallName",
          field: "educationKindCdSmallName",
          // 교육종류2
          label: "LBL0002934",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          name: "educationTypeNames",
          field: "educationTypeNames",
          // 교육구분
          label: "LBL0002935",
          style: 'width:100px',
          align: "center",
          sortable: true,
        },
        {
          label: yearLabel,
          align: 'center',
          sortable: false,
          child: yearmonth
        },
        {
          name: "relatedLawsName",
          field: "relatedLawsName",
          // 관련법규
          label: "LBL0002804",
          style: 'width:200px',
          align: "left",
          sortable: true,
        },
        {
          name: "departmentDeptNames",
          field: "departmentDeptNames",
          // 주관부서
          label: "LBL0002854",
          style: 'width:120px',
          align: "left",
          sortable: true,
        },
      ]
      // this.searchParam.educationYear = this.$comm.getThisYear();
      this.getList();
    },
    getList() {
      if (!this.searchParam.educationYear) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 
          // item.equipmentNm + 
          'MSG0000857', // 교육년도를 선택하세요.
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      // 전체조회
      this.getYearEdu();
      this.searchYear = this.$_.clone(this.searchParam.educationYear);

      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;

        this.$_.forEach(this.grid.data, _item => {
          _item.eduKey = uid();
        })
      },);
    },
    getYearEdu() {
      // 전체조회
      this.$http.url = this.$format(this.yearEduDetailUrl, this.searchParam.plantCd, this.searchParam.educationYear);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        if (_result.data) {
          this.yearEdu = _result.data;
        } else {
          Object.assign(this.$data.yearEdu, this.$options.data().yearEdu);
        }
        this.suffixLabel = this.$comm.getLangLabel('LBL0002849', {s1: this.searchYear, s2: this.yearEdu.plantName, s3: this.yearEdu.approvalStatusName})
      },);
    },
    linkClick(row, col) {
      let title = '';
      let param = null;
      if (!col) {
        this.popupOptions.target = () =>
          import(`${"./annualEducationPlanDetail.vue"}`);
          param = {
            disabled: false,
            eduEducationId: '',
            eduCourseId: '',
          };
        this.popupOptions.isFull = false;
        title = 'LBL0002855'; // 연간교육계획 상세

      } else if (col.name === 'educationCourseName') {
        this.popupOptions.target = () =>
          import(`${"@/pages/sop/edu/cc/educationCourseDetail.vue"}`);
          param = {
            eduCourseId: row.eduCourseId ? row.eduCourseId : '',
          };
        this.popupOptions.isFull = true;
          title = 'LBL0002856'; // 교육과정 마스터 상세
      } else {
        this.popupOptions.target = () =>
          import(`${"./annualEducationPlanDetail.vue"}`);
          param = {
            eduEducationId: row.eduEducationId ? row.eduEducationId : '',
            eduCourseId: row.eduCourseId ? row.eduCourseId : '',
            educationMonth: row ? col.name.substring(col.name.length - 2) : '',
            educationYear: row ? row.educationYear : '',
            plantCd: row ? row.plantCd : '',
            disabled: true,
            /**
             * 2022-05-12 kdh
             * 교육, 결과/완료 구분자 param
             */
            stepFlag: col.name.indexOf('plan') > -1 ? 'N' : 'Y',
            approvalStatusCd: this.yearEdu.approvalStatusCd
          };
        this.popupOptions.isFull = false;
        // result.educationCourseName + '의 ' + this.searchYear + '년 ' +
        // col.label + ' 연간교육계획 상세'
        title = this.$comm.getLangLabel('LBL0002857', {s1: row.educationCourseName, s2: this.searchYear, s3: col.name.indexOf('plan') > -1 ? '계획' : '결과'})
      }
      this.popupOptions.title = title;
      this.popupOptions.param = param;
      this.popupOptions.width = '95%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.$refs['table'].selected = []
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>